/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartGetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCartGetResponse } from '../../models/index.js';
// @ts-ignore
import { CouponRequestBuilderRequestsMetadata, type CouponRequestBuilder } from './coupon/index.js';
// @ts-ignore
import { DomainRequestBuilderRequestsMetadata, type DomainRequestBuilder } from './domain/index.js';
// @ts-ignore
import { DomainSubscriptionPaymentIntervalRequestBuilderRequestsMetadata, type DomainSubscriptionPaymentIntervalRequestBuilder } from './domainSubscriptionPaymentInterval/index.js';
// @ts-ignore
import { FinalizeRequestBuilderRequestsMetadata, type FinalizeRequestBuilder } from './finalize/index.js';
// @ts-ignore
import { Item_EscapedRequestBuilderNavigationMetadata, type Item_EscapedRequestBuilder } from './item_Escaped/index.js';
// @ts-ignore
import { LinkToCustomerRequestBuilderRequestsMetadata, type LinkToCustomerRequestBuilder } from './linkToCustomer/index.js';
// @ts-ignore
import { Microsoft365RequestBuilderNavigationMetadata, Microsoft365RequestBuilderRequestsMetadata, type Microsoft365RequestBuilder } from './microsoft365/index.js';
// @ts-ignore
import { OrderPrepareRequestBuilderRequestsMetadata, type OrderPrepareRequestBuilder } from './orderPrepare/index.js';
// @ts-ignore
import { QuoteRequestBuilderRequestsMetadata, type QuoteRequestBuilder } from './quote/index.js';
// @ts-ignore
import { type VpsRequestBuilder, VpsRequestBuilderRequestsMetadata } from './vps/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}
 */
export interface WithCartItemRequestBuilder extends BaseRequestBuilder<WithCartItemRequestBuilder> {
    /**
     * The coupon property
     */
    get coupon(): CouponRequestBuilder;
    /**
     * The domain property
     */
    get domain(): DomainRequestBuilder;
    /**
     * The domainSubscriptionPaymentInterval property
     */
    get domainSubscriptionPaymentInterval(): DomainSubscriptionPaymentIntervalRequestBuilder;
    /**
     * The finalize property
     */
    get finalize(): FinalizeRequestBuilder;
    /**
     * The item property
     */
    get item(): Item_EscapedRequestBuilder;
    /**
     * The linkToCustomer property
     */
    get linkToCustomer(): LinkToCustomerRequestBuilder;
    /**
     * The microsoft365 property
     */
    get microsoft365(): Microsoft365RequestBuilder;
    /**
     * The orderPrepare property
     */
    get orderPrepare(): OrderPrepareRequestBuilder;
    /**
     * The quote property
     */
    get quote(): QuoteRequestBuilder;
    /**
     * The vps property
     */
    get vps(): VpsRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCartItemRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCartItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCartItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    coupon: {
        requestsMetadata: CouponRequestBuilderRequestsMetadata,
    },
    domain: {
        requestsMetadata: DomainRequestBuilderRequestsMetadata,
    },
    domainSubscriptionPaymentInterval: {
        requestsMetadata: DomainSubscriptionPaymentIntervalRequestBuilderRequestsMetadata,
    },
    finalize: {
        requestsMetadata: FinalizeRequestBuilderRequestsMetadata,
    },
    item: {
        navigationMetadata: Item_EscapedRequestBuilderNavigationMetadata,
    },
    linkToCustomer: {
        requestsMetadata: LinkToCustomerRequestBuilderRequestsMetadata,
    },
    microsoft365: {
        requestsMetadata: Microsoft365RequestBuilderRequestsMetadata,
        navigationMetadata: Microsoft365RequestBuilderNavigationMetadata,
    },
    orderPrepare: {
        requestsMetadata: OrderPrepareRequestBuilderRequestsMetadata,
    },
    quote: {
        requestsMetadata: QuoteRequestBuilderRequestsMetadata,
    },
    vps: {
        requestsMetadata: VpsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCartItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCartItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
